const DyStepOne = () => import('@/views/purchaseProcess/commonMode/dy/stepOne')
const DyStepTwo = () => import('@/views/purchaseProcess/commonMode/dy/stepTwo')
const DyStepThree = () => import('@/views/purchaseProcess/commonMode/dy/stepThree')
const DyQuestionOne = () => import('@/views/purchaseProcess/commonMode/dy/quesAndAnswers/QuestionOne')
const DyQuestionTwo = () => import('@/views/purchaseProcess/commonMode/dy/quesAndAnswers/QuestionTwo')
const DyQuestionThree = () => import('@/views/purchaseProcess/commonMode/dy/quesAndAnswers/QuestionThree')

export default [
  {
    name: 'dyStepOne',
    path: '/dyStepOne',
    component: DyStepOne,
    meta: {
      title: '第一步'
    }
  },
  {
    name: 'dyStepTwo',
    path: '/dyStepTwo',
    component: DyStepTwo,
    meta: {
      title: '第二步'
    }
  },
  {
    name: 'dyStepThree',
    path: '/dyStepThree',
    component: DyStepThree,
    meta: {
      title: '第三步'
    }
  },
  // 拼多多问题回答
  {
    name: 'dyQuestionOne',
    path: '/dyQuestionOne',
    component: DyQuestionOne
  },
  {
    name: 'dyQuestionTwo',
    path: '/dyQuestionTwo',
    component: DyQuestionTwo
  },
  {
    name: 'dyQuestionThree',
    path: '/dyQuestionThree',
    component: DyQuestionThree
  }
]
